import { Event } from "../../../../../../Global/Base/Events";
import { NumberUtils } from "../../../../../../Global/Base/Utils/NumberUtils";
import { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
import { Globalization } from "../../../../../../Global/Dom/Globalization";
import { IExtendedFilterOperation, IExtendedFilterParser } from "../FilterInterfaces";
import { FilterRegistrations } from "../FilterRegistrations";
/** Zpracuje vstup z rozšířeného filtru do struktury používané pro práci s flitry */
export class ExtendedFilterParser implements IExtendedFilterParser {
    //#region Fields
    /** Událost vyvolaná při chybě během parsování */
    private readonly _failed: Event<ExtendedFilterParser, string> = new Event<ExtendedFilterParser, string>();
    //#endregion Fields

    //#region Properties
    /** Událost vyvolaná při chybě během parsování */
    public get failed(): Event<ExtendedFilterParser, string> { // Bez použití getteru nefunguje kontrola při registraci do DI
        return this._failed;
    }
    //#endregion Properties

    //#region Methods
    /**
     * Zpracuje vstup rozšířeného filtru do struktury pro vytváření filtrů
     * @param input Vstupní data
     * @param dataType Datový typ sloupce
     */
    public parse(input: string | undefined | null, dataType: string): IExtendedFilterOperation[] {
        if (!input) {
            return [];
        }

        const operations: IExtendedFilterOperation[] = [];
        const orConditions = this._splitByCharacter(input, "|"); //input.split(/(?<!\\)\|/); // Negative Lookbehind umí jen Blink

        for (const condition of orConditions) {
            const andConditions = this._splitByCharacter(condition, "&"); //condition.split(/(?<!\\)&/); // Negative Lookbehind umí jen Blink
            const value = andConditions[0].trim();

            if (!this._validate(value, dataType)) {
                return [];
            }

            operations.push({ operator: "or", value: { value: value, userValue: value, fieldId: undefined, fieldType: undefined } });

            andConditions.splice(0, 1);

            for (let value of andConditions) {
                value = value.trim();

                if (!this._validate(value, dataType)) {
                    return [];
                }

                operations.push({ operator: "and", value: { value: value, userValue: value, fieldId: undefined, fieldType: undefined } });
            }
        }

        return operations;
    }

    /**
     * Rozdělí vstup na pole řetězců rozdělených podle požadovaného oddělovače
     * @param input Vstup
     * @param separator Podle něj je rozdělen vstup do sub řetězců
     */
    private _splitByCharacter(input: string, separator: string): string[] {
        const values: string[] = [];
        let previousChar: string;
        let value = "";

        input.split("").forEach((character) => {
            if (character === separator) {
                if (previousChar === "\\") {
                    value = value.slice(0, -1);
                } else {
                    values.push(value);

                    value = "";

                    return;
                }
            }

            value += character;
            previousChar = character;
        });

        values.push(value);

        return values;
    }

    /**
     * Provede validaci vstupní hodnoty a zobrazí případnou informaci o jejím nesplnění
     * @param value Vstupní hodnota k validaci
     * @param dataType Datový typ
     */
    protected _validate(value: string, dataType: string): boolean {
        if (!StringUtils.isNullOrEmpty(value)) {
            if (FilterRegistrations.numericTypes.includes(dataType)) {
                const format = Globalization.numberFormat;

                value = NumberUtils.removeFormatting(value, format.groupSeparator, format.decimalSeparator);

                if (!Number.isNaN(+value)) {
                    return true;
                }
            }

            if (FilterRegistrations.stringTypes.includes(dataType) || dataType === "enum") {
                return true;
            }
        }

        this._failed.trigger(this, value);

        return false;
    }
    //#endregion Methods
}
